import { useEffect } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import EngagementWizard from "../EngagementWizard";
import InviteManagementPage from "../InviteManagementPage";
import NexusSurfaceShell from "./NexusSurfaceShell";
import { ROUTES } from "../routes";
import { LensComposeIcon, LensPipelineIcon } from "./surfaceIcons";

const LENSES = [
  { id: "compose", label: "Compose", desc: "Invite · customize · send", icon: <LensComposeIcon /> },
  { id: "pipeline", label: "Pipeline", desc: "Manage · reports · resend", icon: <LensPipelineIcon /> },
];

const TITLES = {
  compose: "Compose invites",
  pipeline: "Participant pipeline",
};

const SUBTITLES = {
  compose: "Pick a company, add participants, customize email, and launch.",
  pipeline: "Track every participant, resend invites, assign report profiles, and open deliverables.",
};

export default function EngagementPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const lensParam = searchParams.get("lens");
  const lens = lensParam === "pipeline" ? "pipeline" : "compose";
  const { setAdminAssistantContext } = useOutletContext() || {};

  useEffect(() => {
    if (lensParam === "wizard" || lensParam === "compose") {
      setSearchParams({}, { replace: true });
    }
  }, [lensParam, setSearchParams]);

  const setLens = (id) => {
    setSearchParams(id === "compose" ? {} : { lens: id });
  };

  useEffect(() => {
    setAdminAssistantContext?.({
      page: lens === "pipeline" ? "invites" : "invite",
      surface: "engagement",
      currentRoute: `${ROUTES.engagement}${lens === "compose" ? "" : "?lens=pipeline"}`,
      scope: {
        label: "Engagement",
        text: SUBTITLES[lens],
      },
      activeLens: lens,
    });
    return () => setAdminAssistantContext?.(null);
  }, [lens, setAdminAssistantContext]);

  return (
    <NexusSurfaceShell
      surfaceId="engagement"
      eyebrow="Engagement"
      title={TITLES[lens]}
      subtitle={SUBTITLES[lens]}
      lenses={LENSES}
      activeLens={lens}
      onLensChange={setLens}
    >
      {lens === "compose" ? <EngagementWizard embedded /> : <InviteManagementPage embedded />}
    </NexusSurfaceShell>
  );
}
